type FreeDeliveryFlagCandidate = {
  title: string;
};

type CalculatedDeliveryCandidate = {
  delivery_price: number;
  is_free: boolean;
};

export function isFreeDeliveryMarketingFlag(flag: FreeDeliveryFlagCandidate) {
  return flag.title.toLowerCase().trim() === 'бесплатная доставка';
}

export function shouldShowFreeDeliveryFlag(usedIn: 'category' | 'offer', isFreeDeliveryAvailable: boolean | undefined) {
  return usedIn === 'offer' && isFreeDeliveryAvailable === true;
}

export function isFreeDeliveryAvailableFromDeliveryCalculation(
  deliveries: CalculatedDeliveryCandidate[] | null | undefined,
) {
  return deliveries?.some((delivery) => delivery.is_free === true && delivery.delivery_price === 0) ?? false;
}
